export default "__VITE_ASSET__BLWEUa_3__"